<template>
    <div class="h-full w-full">
        Construyendo la seccion de: Relojes
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>